import React, { useEffect, useState } from 'react';

const LandingPage = () => {
  // Domain name from the example
  const domainName = "wldcoin.org";
  const [isMounted, setIsMounted] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    setIsMounted(true);
    
    const handleMouseMove = (e) => {
      // Subtle mouse movement effect
      setMousePosition({
        x: e.clientX / window.innerWidth,
        y: e.clientY / window.innerHeight
      });
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      setIsMounted(false);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <div className="flex items-center justify-center w-full h-screen bg-black">
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: "radial-gradient(circle at 50% 50%, #1a1a1a 0%, transparent 70%)",
          backgroundSize: "100% 100%",
          backgroundPosition: `${50 + mousePosition.x * 3}% ${50 + mousePosition.y * 3}%`
        }}
      ></div>
      <div className={`relative transition-all duration-1000 ${isMounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-sans font-bold text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-gray-500 tracking-tight">
          {domainName}
        </h1>
        <div className="absolute -inset-1 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-800 rounded-lg opacity-15 blur-md -z-10"></div>
        <div className="h-px w-full bg-gradient-to-r from-transparent via-gray-600 to-transparent mt-3 opacity-30"></div>
        <div className="absolute inset-0 bg-black/20 backdrop-blur-3xl -z-20 rounded-xl"></div>
      </div>
    </div>
  );
};

export default LandingPage;